import { useState } from "react";
import useApi from "./useApi";
import { API_ROUTES } from "lib/constants/api-constants";

interface SessionBookingsState {
    loading: boolean;
    error: string | null;
    SessionBooking: SessionBookingDetails[];

    getSessionBookingsDetails: (
        sessionId: string,
        onSuccess?: (SessionBooking: SessionBookingDetails[]) => void
    ) => void;

    updateSessionBooking: (
        sessionId: string,
        fromTime: string,
        duration: number,
        onSuccess?: (SessionBooking: SessionBookingDetails[]) => void
    ) => void;
}

const useTherapySessionBookings = (): SessionBookingsState => {
    const [error, setError] = useState<string | null>();
    const [SessionBooking, setSessionBooking] = useState<SessionBookingDetails[]>([]);

    const {
        getData: getSessionBookingsDetailsRequest,
        loading: getSessionBookingsDetailsRequestLoading,
    } = useApi<SessionBookingDetails[]>();

    const {
        postData: updateSessionBookingRequest,
        loading: updateSessionBookingRequestLoading,
    } = useApi<SessionBookingDetails[]>();

    const getSessionBookingsDetails = async (
        sessionId: string,
        onSuccess?: (sessionBooking: SessionBookingDetails[]) => void
    ) => {
        const endPoint = API_ROUTES.SESSION_BOOKING.getSession.replace("{{SESSION_ID}}", sessionId);
        await getSessionBookingsDetailsRequest(endPoint, onSuccess, setError);
    };

    const updateSessionBooking = async (
        sessionId: string,
        fromTime: string,
        duration: number,
        onSuccess?: (sessionBooking: SessionBookingDetails[]) => void
    ) => {
        const endPoint = API_ROUTES.SESSION_BOOKING.updateSession.replace("{{SESSION_ID}}", sessionId);
        await updateSessionBookingRequest(endPoint, {sessionId, fromTime, duration}, onSuccess, setError);
    };

    return {
        loading: getSessionBookingsDetailsRequestLoading || updateSessionBookingRequestLoading,
        error,
        SessionBooking,
        getSessionBookingsDetails,
        updateSessionBooking,
    };
};

export default useTherapySessionBookings;
